import React from 'react'
import { Pagination as RaPagination } from 'react-admin'

const Pagination = (props) => (
  <RaPagination rowsPerPageOptions={[200, 400, 600]} {...props} />
)

export default Pagination
